import { Image } from 'semantic-ui-react';
export default Image;